var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1200_4278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.599 0.5H5.40094C2.42423 0.5 0.00238037 2.92185 0.00238037 5.89856V10.0974C0.00238037 12.9737 2.26318 15.3316 5.10102 15.4879V17.9904C5.10102 18.2715 5.33016 18.5 5.61178 18.5C5.74645 18.5 5.87391 18.4466 5.97019 18.3503L6.53284 17.7877C8.01025 16.31 9.97502 15.496 12.0649 15.496H12.599C15.5757 15.496 17.9976 13.0741 17.9976 10.0974V5.89856C17.9976 2.92185 15.5757 0.5 12.599 0.5ZM5.10102 9.19768C4.4394 9.19768 3.90134 8.65962 3.90134 7.998C3.90134 7.33638 4.4394 6.79832 5.10102 6.79832C5.76264 6.79832 6.3007 7.33638 6.3007 7.998C6.3007 8.65962 5.76234 9.19768 5.10102 9.19768ZM8.99998 9.19768C8.33836 9.19768 7.8003 8.65962 7.8003 7.998C7.8003 7.33638 8.33836 6.79832 8.99998 6.79832C9.6616 6.79832 10.1997 7.33638 10.1997 7.998C10.1997 8.65962 9.6613 9.19768 8.99998 9.19768ZM12.8989 9.19768C12.2373 9.19768 11.6993 8.65962 11.6993 7.998C11.6993 7.33638 12.2373 6.79832 12.8989 6.79832C13.5606 6.79832 14.0986 7.33638 14.0986 7.998C14.0986 8.65962 13.5603 9.19768 12.8989 9.19768Z",
    fill: "#111F3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1200_4278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.44ca2be0989ff9e9c8fb22ed25c3d28b.svg";
export { ForwardRef as ReactComponent };